import { getRouteFromPage } from './get-route-from-page';

export const getRouteFromPageIndex = (pages, pageIndex) => {
  if (!pages || !Array.isArray(pages)) return;

  return getRouteFromPage(pages[pageIndex]);
};
